import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { isTokenExpired } from "services/utility/storage";
import { logoutAuth } from 'services/http/auth';


export const PrivateRoute = ({ component: Component, ...rest }) => {

    const auth = useSelector((state) => state.auth);
    const dispatch = useDispatch();
    const logout = () =>{
        dispatch(logoutAuth(false));
    }
    
    

    return (

        <Route {...rest} render={props => {
            if (!auth.isAuthenticated) {
                // not logged in so redirect to login page with the return url
                return <Redirect to={{ pathname: '/auth/login'}} />
            }
            else {
                if (isTokenExpired()) {
                    logout();
                    return <Redirect to={{ pathname: '/auth/login' }} />
                }

            }

            // authorised so return component
            return <Component {...props} />
        }} />


    )
}

export default PrivateRoute;